import { ModalAddModeReglComponent } from './../../../shared/components/modals/modal-add-mode-regl/modal-add-mode-regl.component';
import { ModeReglService } from 'src/app/shared/services/simple/mode-regl.service';
import { ReferentielDTO } from './../../../shared/dtos/referentielDTO';
import { SimpleQueryResponse } from './../../../shared/dtos/simpleQueryResponse';
import { LegacyPageEvent as PageEvent, MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { ModeReglModel } from './../../../shared/models/simple-types/modeRegl.model';
import { ModalInfoOkComponent } from 'src/app/shared/components/modals/info-ok/modal-info-ok.component';
import { GestionReferentielComponentService } from '../gestion-referentiel-component.service';
import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';

@Component({
  selector: 'app-gestion-mode-regl',
  templateUrl: './gestion-mode-regl.component.html',
  styleUrls: ['./gestion-mode-regl.component.scss']
})
export class GestionModeReglComponent implements OnInit {


  modeRegls: ModeReglModel[] = [];
  displayedColumns: string[] = ['code', 'libelle', 'codeCompta', 'codeNTH', 'action'];
  dataSource: ModeReglModel[];
  matDataSource = new MatTableDataSource<ModeReglModel>();
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageSize = 25;
  pageEvent: PageEvent;
  result: boolean;
  objet: SimpleQueryUser = new SimpleQueryUser();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private toastrService: ToastrService,
    private modeReglService: ModeReglService,
    private gestionReferentielComponent: GestionReferentielComponentService) { }

  ngOnInit(): void {
    this.objet.query = '';
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.objet.order = 'libelle';
    this.matDataSource.paginator = this.paginator;
    this.loadPage();
  }

  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateModeReglFormGroup();
    const dialogRef = this.dialog.open(ModalAddModeReglComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form,
          modeRegls: this.modeRegls,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });

  }

  onModify(modeRegl: ModeReglModel): void {
    const form = this.gestionReferentielComponent.getEditModeReglFormGroup(modeRegl);
    const dialogRef = this.dialog.open(ModalAddModeReglComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form,
          modeRegls: this.modeRegls,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });
  }


  onDelete(modeRegl: ModeReglModel): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Suppression du mode de réglement',
        message: 'Êtes-vous sur de vouloir supprimer le mode de réglement ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.modeReglService.delete(modeRegl.id).subscribe((response: ModeReglModel) => {
          this.toastrService.success('Le mode de réglement a bien été supprimé');
          this.loadPage();
        });
      }
    });
  }


  orderUsers(modeRegls: ModeReglModel[]): ModeReglModel[] {
    modeRegls = modeRegls.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return modeRegls;
  }

  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    this.modeReglService.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<ModeReglModel>) => {
      if (query.objets != null) {
        this.modeRegls = query.objets;
      } else {
        this.modeRegls = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<ModeReglModel>(this.modeRegls);
      this.paginator.length = this.length;
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }
}

